import {
	type LayoutNavComponentProps,
	SvgFromUrl,
	TrackingLink,
} from '@ds-mgnl/marketing';
import { classNames } from '@dsx/react';
import logoSvg from '../assets/images/ds-logo.svg';
import styles from './DsLogo.module.css';

export type DsLogoProps = LayoutNavComponentProps;

export function DsLogo({ transparent }: DsLogoProps) {
	return (
		<TrackingLink href="/" clickType="header_link" trackingText="Top Nav Logo">
			<SvgFromUrl
				url={logoSvg}
				height={'37px'}
				className={classNames(styles['aptura-logo'], {
					[styles['transparent']]: transparent,
				})}
			/>
		</TrackingLink>
	);
}
